import React from 'react';
// TODO: Migrate module so that you don’t import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import SectionTitle from 'corp/components/UI/SectionTitle';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import UploadTasksToCustomer from 'react-scale/corp/components/BeeRLHF/UploadTasksToCustomer';

const BeeRLHFUtilsPage = () => {
  return (
    <div className="root">
      <SectionTitle title="Bee RLHF Actions" />
      <Section name={`Upload tasks to customer`} forceHidden={false}>
        <UploadTasksToCustomer />
      </Section>
    </div>
  );
};

export default BeeRLHFUtilsPage;
